<template>
  <el-dialog
      :title="setId?'编辑考官':'新增考官'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="examinerForm" :rules="rules" ref="examinerForm" label-width="100px">
      <el-form-item label="考官编号" prop="number" v-if="this.setId">
        <el-input v-model="examinerForm.number" placeholder="请输入考官编号"></el-input>
      </el-form-item>
      <el-form-item label="考官类型" prop="type">
        <el-select v-model="examinerForm.type" placeholder="请选择考官类型" style="width: 100%;">
          <el-option label="专业考官" value="1"></el-option>
          <el-option label="HR考官" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考官姓名" prop="name">
        <el-input v-model="examinerForm.name" placeholder="请输入考官姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idcard">
        <el-input v-model="examinerForm.idcard" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="examinerForm.phone" placeholder="请输入电话"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="examinerForm.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bank">
        <el-input v-model="examinerForm.bank" placeholder="请输入开户行"></el-input>
      </el-form-item>
      <el-form-item label="银行卡号" prop="bank_card">
        <el-input v-model="examinerForm.bank_card" placeholder="请输入银行卡号"></el-input>
      </el-form-item>
      <el-form-item label="所在单位" prop="danwei">
        <el-input v-model="examinerForm.danwei" placeholder="请输入所在单位"></el-input>
      </el-form-item>
      <el-form-item label="邮寄地址" prop="address">
        <el-input v-model="examinerForm.address" placeholder="请输入邮寄地址"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="desc">
        <el-input type="textarea" v-model="examinerForm.desc" placeholder="请输入简介"></el-input>
      </el-form-item>
      <el-form-item label="个人正面照" prop="photo">
        <el-upload
            class="avatar-uploader"
            :action="upUrl + '/admin/upload'"
            :name="'image'"
            :data="fileData"
            :show-file-list="false"
            accept="image/*"
            :on-success="handleAvatarSuccess"
        >
          <img v-if="examinerForm.photo" :src="imgUrl + examinerForm.photo" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('examinerForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('examinerForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {examinerAdd} from "@/api/projectOffice";
import {IMGURL, UPFILE} from "@/config";
import rules from '@/tools/rules'
export default {
  name: "examinerDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
// 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[0-9]{10}$/;
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("手机号码格式不正确"));
          }
        }
      }, 100);
    };
    return {
      examinerForm: {
        number:'',
        type: '',
        name: '',
        idcard: '',
        phone: '',
        email: '',
        bank: '',
        bank_card: '',
        danwei: '',
        address: '',
        photo: '',
        desc:''
      },
      rules: {
        number: [{required: true, message: '请输入考官编号', trigger: 'blur'},],
        type: [{required: true, message: "请选择考官类型", trigger: "change"}],
        name: [{required: true, message: '请输入考官姓名', trigger: 'blur'},],
        idcard: rules.idcard,
        phone: [{required: true, validator: checkPhone, trigger: "blur"}],
        email: [{required: true, message: '请输入邮箱', trigger: 'blur'}, {
          type: "email",
          message: "请输入正确的邮箱地址",
          trigger: "blur"
        }],
        bank: [{required: true, message: '请输入开户行', trigger: 'blur'},],
        bank_card: [{required: true, message: '请输入银行卡号', trigger: 'blur'},],
        danwei: [{required: true, message: '请输入所在单位', trigger: 'blur'},],
        address: [{required: true, message: '请输入邮寄地址', trigger: 'blur'},],
        photo: [{required: true, message: "请上传个人正面照", trigger: "change"}],
      },
    }
  },
  computed: {
    fileData() {
      return {
        u_token: this.$store.state.token2
      };
    },
    upUrl() {
      return UPFILE
    },
    imgUrl() {
      return IMGURL
    }
  },
  created() {

  },
  methods: {
    handleAvatarSuccess(res) {
      if (res.code === 1002) {
        this.examinerForm.photo = res.data.path
        this.$refs.examinerForm.validateField('photo')
      } else {
        this.$message.error(res.data)
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await examinerAdd(
          this.examinerForm.number,
          this.examinerForm.type,
          this.examinerForm.name,
          this.examinerForm.idcard,
          this.examinerForm.phone,
          this.examinerForm.email,
          this.examinerForm.bank,
          this.examinerForm.bank_card,
          this.examinerForm.danwei,
          this.examinerForm.address,
          this.examinerForm.photo,
          this.examinerForm.desc,
          this.setId ? this.setId : '',
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.examinerForm = {
        number: this.setItem.number,
        type: this.setItem.type?this.setItem.type.toString():'',
        name: this.setItem.name,
        idcard: this.setItem.idcard,
        phone: this.setItem.phone,
        email: this.setItem.email,
        bank: this.setItem.bank,
        bank_card: this.setItem.bank_card,
        danwei: this.setItem.danwei,
        address: this.setItem.address,
        photo: this.setItem.photo,
        desc:this.setItem.desc,
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>